import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { Lock } from "lucide-react";
import { api, formatApiErrorDetail } from "../lib/api";
import { Logo } from "../components/SiteLayout";

export default function AdminLoginPage() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const onSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await api.post("/auth/login", { email, password });
      navigate("/admin");
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div data-testid="admin-login-page" className="min-h-screen bg-[#113835] tt-grain flex items-center justify-center px-6">
      <div className="w-full max-w-md">
        <div className="bg-white border border-white/20 p-10 md:p-12">
          <div className="flex flex-col items-start gap-6 mb-10">
            <Logo />
            <div>
              <h1 className="font-heading text-2xl font-medium text-[#113835] flex items-center gap-3">
                <Lock size={20} strokeWidth={1.25} className="text-[#C1A74A]" /> Admin Login
              </h1>
              <p className="text-sm text-gray-500 font-light mt-2">Restricted to Terraa & Title staff.</p>
            </div>
          </div>
          <form onSubmit={onSubmit} className="space-y-8" data-testid="admin-login-form">
            <div>
              <label className="tt-label" htmlFor="admin-email">Email Address</label>
              <input id="admin-email" data-testid="admin-login-email" type="email" required className="tt-input" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="admin email" />
            </div>
            <div>
              <label className="tt-label" htmlFor="admin-password">Password</label>
              <input id="admin-password" data-testid="admin-login-password" type="password" required className="tt-input" value={password} onChange={(e) => setPassword(e.target.value)} placeholder="password" />
            </div>
            {error && <p data-testid="admin-login-error" className="text-sm text-red-600 font-light">{error}</p>}
            <button data-testid="admin-login-submit" type="submit" disabled={loading} className="tt-btn-primary w-full justify-center disabled:opacity-60">
              {loading ? "Signing in..." : "Sign In"}
            </button>
          </form>
        </div>
        <p className="text-center mt-6">
          <Link to="/" data-testid="admin-back-to-site" className="text-xs text-white/60 hover:text-[#F4D387] transition-colors tracking-widest uppercase">← Back to website</Link>
        </p>
      </div>
    </div>
  );
}
